import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TournamentSelector = ({ value, onChange, className = "", showAllOption = false }) => {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTournaments();
  }, []);

  const fetchTournaments = async () => {
    try {
      const response = await axios.get(`${API}/tournaments`, {
        withCredentials: true,
      });
      const activeTournaments = response.data.tournaments.filter(t => t.is_active);
      setTournaments(activeTournaments);
      
      // Auto-select default tournament if current value is 'all' or empty
      if ((!value || value === 'all') && activeTournaments.length > 0 && onChange) {
        const defaultTournament = activeTournaments.find(t => t.is_default);
        if (defaultTournament) {
          // If there's a default tournament, select it
          onChange(defaultTournament.name);
        } else if (!value) {
          // If no default and value is empty, select first tournament
          onChange(activeTournaments[0].name);
        }
      }
    } catch (error) {
      console.error('Failed to fetch tournaments:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Select disabled>
        <SelectTrigger className={className}>
          <SelectValue placeholder="Loading tournaments..." />
        </SelectTrigger>
      </Select>
    );
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select tournament" />
      </SelectTrigger>
      <SelectContent>
        {showAllOption && (
          <SelectItem value="all">All Tournaments</SelectItem>
        )}
        {tournaments.map((tournament) => (
          <SelectItem key={tournament.tournament_id} value={tournament.name}>
            {tournament.name}
            {tournament.is_default && ' (Default)'}
          </SelectItem>
        ))}
        {tournaments.length === 0 && (
          <div className="p-2 text-sm text-muted-foreground">
            No tournaments available
          </div>
        )}
      </SelectContent>
    </Select>
  );
};

export default TournamentSelector;
